import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
//LZ import {FILTER_TYPE, FilterInterface} from './filter.interface';
import {FILTER_TYPE, FilterInterface} from 'libComm';
//LZ import {IMultiSelectOption, IMultiSelectSettings} from "../../custom-multiselect/types";
import {IMultiSelectOption, IMultiSelectSettings} from "libComm";
import {GeneralService} from "../../../../services/crud/general.service";
import {Observable} from "rxjs";

@Component({
  selector: "custom-filter[filterModel]",
  templateUrl: "./custom-filter.component.html",
  styleUrls: ["./custom-filter.component.scss"],
})
export class CustomFilterComponent implements OnInit {
  filterType = FILTER_TYPE;

  @Input()
  filterModel!: FilterInterface;

  @Input()
  filterValues?: Observable<any>;

  @Output()
  filterModelChange: EventEmitter<FilterInterface> = new EventEmitter<FilterInterface>();

  @Output()
  onEnterEmit: EventEmitter<any> = new EventEmitter<any>();

  multisSelectSettings : IMultiSelectSettings = {
    displayAllSelectedText: true,
    itemClasses: 'custom-menu-item',
    closeOnClickOutside: true,
    pullRight: false,
    enableSearch: true,
    searchRenderLimit: 0,
    searchRenderAfter: 1,
    searchMaxLimit: 0,
    searchMaxRenderedItems: 0,
    checkedStyle: 'checkboxes',
    buttonClasses: 'btn-dropdown',
    containerClasses: 'dropdown-inline',
    selectionLimit: 0,
    minSelectionLimit: 0,
    closeOnSelect: false,
    autoUnselect: false,
    showCheckAll: false,
    showUncheckAll: false,
    fixedTitle: false,
    dynamicTitleMaxItems: 3,
    maxHeight: '300px',
    isLazyLoad: false,
    stopScrollPropagation: false,
    loadViewDistance: 1,
    selectAddedValues: false,
    ignoreLabels: false,
    maintainSelectionOrderInTitle: false,
    focusBack: true
  }

  constructor(private generalDataService: GeneralService) {
  }

  ngOnInit(): void {
  }

  onChange(event: any): void {
    //(this.filterModel);
    this.filterModel.filterSelectedOption = this.filterModel.lFilterOptions.filter((f) => f.id == event)[0];
    this.filterModelChange.emit(this.filterModel);
  }

  onFirstFilterChange(event: any): void {
    this.filterModel.firstValue = event;
    this.filterModelChange.emit(this.filterModel);
  }

  onSecondFilterChange(event: any): void {
    this.filterModel.secondValue = event;
    this.filterModelChange.emit(this.filterModel);
  }

  onFlagFirstFilterChange(event: string): void {

	  if(event === ""){ //empty value means that user want to reset filter, so we need to set firstValue to null and not to empty string
		  this.filterModel.firstValue = null;
	  }else if(event === "Y"){
		  this.filterModel.firstValue = "Y";
		  this.filterModel.filterSelectedOption = this.filterModel.lFilterOptions.filter((f) => f.id ==  "_:_")[0];
	  }else if(event === "N"){ //N meas "<> Y" or is null
		  this.filterModel.firstValue = "Y";
		  this.filterModel.filterSelectedOption = this.filterModel.lFilterOptions.filter((f) => f.id ==  "_n:null")[0];
	  }
	  this.filterModel.filterSelectedOption.haveSecondParam = false;
	  this.filterModelChange.emit(this.filterModel);
  }
  onClearClick() {
    ////(this.filterModel);
  }

  onEnter($event: any) {
    this.onEnterEmit.emit();
  }
}
